/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Bodymap_Age_Lt6mInputs */

const en_us2_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Less than 6 months ago`)
};

const pt_br2_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há menos de 6 meses`)
};

const es_419_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hace menos de 6 meses`)
};

const pt_pt2_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Há menos de 6 meses`)
};

const fr_fr2_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il y a moins de 6 mois`)
};

const de_de2_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vor weniger als 6 Monaten`)
};

const it_it2_bodymap_age_lt6m = /** @type {(inputs: Bodymap_Age_Lt6mInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meno di 6 mesi fa`)
};

/**
* | output |
* | --- |
* | "Less than 6 months ago" |
*
* @param {Bodymap_Age_Lt6mInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const bodymap_age_lt6m = /** @type {((inputs?: Bodymap_Age_Lt6mInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bodymap_Age_Lt6mInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_bodymap_age_lt6m(inputs)
	if (locale === "es-419") return es_419_bodymap_age_lt6m(inputs)
	if (locale === "pt-PT") return pt_pt2_bodymap_age_lt6m(inputs)
	if (locale === "fr-FR") return fr_fr2_bodymap_age_lt6m(inputs)
	if (locale === "de-DE") return de_de2_bodymap_age_lt6m(inputs)
	if (locale === "it-IT") return it_it2_bodymap_age_lt6m(inputs)
	return en_us2_bodymap_age_lt6m(inputs)
});
export { bodymap_age_lt6m as "bodymap.age.lt6m" }